import Vue from 'vue';
import Router, { RouterOptions } from 'vue-router';
import CustomerRouter from '@/customer/router';
import RuleRouter from '@/rule/router';
import MassRouter from '@/mass/router';
import SettingsRouter from '@/settings/router';
import UserRouter from '@/user/router';
import AccountRouter from '@/account/router';
import UpgradeRouter from '@/upgrade/router';
import Customer from './customer/views/Index.vue';
import Rule from './rule/views/Index.vue';
import Mass from './mass/views/Index.vue';
import Settings from './settings/views/Index.vue';
import User from './user/views/Index.vue';
import Account from './account/views/Index.vue';
import Upgrade from './upgrade/views/Index.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/customer',
      redirect: '/customer/search',
      component: Customer,
      children: CustomerRouter,
    },
    {
      path: '/rule',
      redirect: '/rule/settings',
      component: Rule,
      children: RuleRouter,
    },
    {
      path: '/mass',
      redirect: '/mass/mpgroup',
      component: Mass,
      children: MassRouter,
    },
    {
      path: '/settings',
      redirect: '/settings/subscribe',
      component: Settings,
      children: SettingsRouter,
    },
    {
      path: '/user',
      redirect: '/user/login',
      component: User,
      children: UserRouter,
    },
    {
      path: '/account',
      redirect: '/account/manage',
      component: Account,
      children: AccountRouter,
    },
    {
      path: '/upgrade',
      redirect: '/upgrade/buy',
      component: Upgrade,
      children: UpgradeRouter,
    },
    // 以下的路由通配必须在最后一项
    {
      path: '*',
      redirect: '/customer',
    },
  ],
} as RouterOptions);
